import Vue from 'vue';
import Vuex from 'vuex';

import alerts from './modules/alerts';
import auth from './modules/auth';
import brands from './modules/brands';
import countries from './modules/countries';
import currencies from './modules/currencies';
import customerGroups from './modules/customerGroups';
import dialCodes from './modules/dialCodes';
import images from './modules/images';
import languages from './modules/languages';
import orders from './modules/orders';
import orderDetail from './modules/orderDetail';
import orderStates from './modules/orderStates';
import paymentMethods from './modules/paymentMethods';
import settings from './modules/settings';
import shippingMethods from './modules/shippingMethods';
import users from './modules/users';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alerts,
    auth,
    brands,
    countries,
    currencies,
    customerGroups,
    dialCodes,
    images,
    languages,
    orders,
    orderDetail,
    orderStates,
    paymentMethods,
    settings,
    shippingMethods,
    users,
  },
});
